import { ErrorHandler, Injectable, Injector } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { AppUpdateRecoveryService } from '../services/app-update-recovery.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
	private sentryHandler = Sentry.createErrorHandler({ showDialog: false });

	constructor(private injector: Injector) {}

	handleError(error: any): void {
		if (this.injector.get(AppUpdateRecoveryService).recoverFromError(error)) {
			return;
		}

		this.sentryHandler.handleError(error);

		console.error('Global Error:', error);
	}
}
